ALLOWED_CONTROLLER = 'door_sentries'
ALLOWED_ACTIONS = ['create', 'edit', 'new']

ready = ->
  return unless continueIfAllowed(ALLOWED_CONTROLLER, ALLOWED_ACTIONS)

  level_1 = $('#door_sentry_level_1')
  level_2 = $('#door_sentry_level_2')
  side_1 = $('#door_sentry_side_1')
  side_2 = $('#door_sentry_side_2')

  level_1.on 'change', ->
    if level_1.val() != ''
      level_2.val(level_1.val())

  level_2.on 'change', ->
    if level_2.val() != ''
      level_1.val(level_2.val())

  side_1.on 'change', ->
    if side_1.val() == '1'
      side_2.val(2)
    else if side_1.val() == '2'
      side_2.val(1)

  side_2.on 'change', ->
    if side_2.val() == '1'
      side_1.val(2)
    else if side_2.val() == '2'
      side_1.val(1)

$(document).ready(ready)
$(document).on('turbo:load', ready)
